export default __webpack_public_path__ + "static/media/serenityseksenalti9.50181ca6.jpg";